import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  }
});

// ─── ESQUEMA TIENDA ───────────────────────────────────────────────────────────
// Cliente centralizado para el esquema personalizado "tienda".
// Usar siempre tiendaDb.from("tabla") en lugar de supabase.from("tienda.tabla")
// o supabase.schema("tienda").from("tabla") para evitar el error "Invalid schema: tienda".
export const tiendaDb = supabase?.schema('tienda');
